import { Icon, ICONS } from '@creditsights/styleguide-web';
import React, { useState, ReactElement } from 'react';
import useGetArticleActions from '../../hooks/articles/useGetArticleActions';
import useFetchUserPermissions from '../../hooks/permissions/useFetchUserPermissions';
import { ArticleTableRow } from '../../models/ArticleTableRow';
import { hasPermissionToShare } from '../../utils/permissionsUtils';
import { ContextMenu, ContextMenuItem } from '../ContextMenu';

interface ArticleContextMenuProps {
  articleTableRow: ArticleTableRow;
  disabled?: boolean;
}

// Note, functionality to add print/download actions to this context menu was implemented but removed.
// Refer to this commit history in case it will ever be needed to add these context menu actions
const ArticleContextMenu = ({ articleTableRow, disabled }: ArticleContextMenuProps): ReactElement | null => {
  const {
    id,
    content: { title },
    publishDate,
    tags,
    canAccess,
  } = articleTableRow;
  const [isOpen, setIsOpen] = useState(false);
  const { data: userPermissions } = useFetchUserPermissions();
  const { onShare, isBookmarkLoading, onBookmark, bookmarkId } = useGetArticleActions({
    id,
    title,
    tags,
    publishDate,
    canAccess,
  });
  const canShare = hasPermissionToShare(userPermissions!);

  return (
    <ContextMenu disabled={disabled} isOpen={isOpen} setIsOpen={setIsOpen}>
      {canShare && <ContextMenuItem icon={<Icon name={ICONS.Share} />} title="Share" action={onShare} />}
      <ContextMenuItem
        icon={<Icon name={bookmarkId ? ICONS.BookmarkFilled : ICONS.Bookmark} />}
        isLoading={isBookmarkLoading}
        title={bookmarkId ? 'Unbookmark' : 'Bookmark'}
        action={onBookmark}
      />
    </ContextMenu>
  );
};

export default React.memo(ArticleContextMenu);
